import { Plus, Star, Trash2 } from 'lucide-react';
import { entryMacros, foodPortion, foodRefMacros, isMassUnit } from '../food';
import { FONT_BODY, FONT_MONO } from '../theme';
import { NumberInput } from '../ui';

/* A tappable food row (used for library, recents, favorites and search results).
 * With `onAmount` it gets an amount field before the +, and the macros line
 * shows that amount instead of the per-100 reference, so the grams are right
 * before it is logged. `addedCount` marks foods already added in this sheet. */
export function FoodRow({ t, food, onPick, onDelete, onToggleFavorite, amount, onAmount, addedCount = 0 }) {
  const stepper = typeof onAmount === 'function';
  const mass = isMassUnit(food.unit);
  const amt = amount != null ? amount : foodPortion(food);
  const ref = foodRefMacros(food);
  const m = stepper ? entryMacros({ per: food.per, amount: amt }) : ref;
  const iconBtn = { flexShrink: 0, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' };
  return (
    <div style={{ display: 'flex', alignItems: 'stretch', borderBottom: `1px solid ${t.divider}` }}>
      <button onClick={() => onPick(food)} style={{
        flex: 1, minWidth: 0, textAlign: 'left', padding: stepper ? '11px 8px 11px 18px' : '11px 4px 11px 18px',
        background: 'transparent', border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center',
      }}
        onMouseEnter={e => e.currentTarget.style.background = t.surfaceAlt}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
        <span style={{ minWidth: 0 }}>
          <span style={{ fontSize: 14, color: t.text, display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{food.name}</span>
            {addedCount > 0 && (
              <span style={{ flexShrink: 0, fontSize: 10, fontWeight: 700, color: t.accent, background: t.accentSoft, borderRadius: 5, padding: '1px 5px', fontFamily: FONT_MONO }}>
                ✓{addedCount > 1 ? ` ×${addedCount}` : ''}
              </span>
            )}
          </span>
          <span style={{ fontSize: 11, color: t.textFaint, fontFamily: FONT_MONO }}>
            {Math.round(m.kcal)} kcal · {Math.round(m.protein)}P {Math.round(m.carbs)}C {Math.round(m.fats)}F
            {!stepper && <span style={{ fontFamily: FONT_BODY }}> / {ref.unit === 'serving' ? 'serving' : `100 ${ref.unit}`}</span>}
          </span>
        </span>
      </button>
      {stepper && (
        <div style={{ width: 84, flexShrink: 0, alignSelf: 'center' }}>
          <NumberInput t={t} value={amt} onChange={onAmount} step={mass ? 10 : 0.5} min={0}
            suffix={mass ? food.unit : '×'} style={{ padding: '9px 8px', paddingRight: 30, fontSize: 13 }} />
        </div>
      )}
      <button onClick={() => onPick(food)} aria-label={`Add ${food.name}`} title="Add" style={{ ...iconBtn, width: 44, justifyContent: 'center', color: t.accent }}>
        <Plus size={18} />
      </button>
      {onToggleFavorite && (
        <button onClick={() => onToggleFavorite(food.id)} title={food.favorite ? 'Remove from favorites' : 'Add to favorites'} style={{
          ...iconBtn, padding: '0 8px', color: food.favorite ? '#f59e0b' : t.textFaint,
        }}>
          <Star size={15} fill={food.favorite ? '#f59e0b' : 'none'} />
        </button>
      )}
      {onDelete && (
        <button onClick={() => onDelete(food.id)} title="Remove from your foods" style={{ ...iconBtn, padding: '0 12px 0 8px', color: t.textFaint }}>
          <Trash2 size={14} />
        </button>
      )}
    </div>
  );
}
